<template>
	<div class="yh_detail_bd">
		<div class="fix_bg" v-if="big_show">
			<div class="no_bg_fix">
				<div class="lun_box">
					<div class="txt_center right close_icon">
						<p class="close_x"></p>
						<i class="el-icon-circle-close" @click="big_show = false"></i>
					</div>
					<el-carousel height="532px" arrow="hover" :initial-index="current_img" :autoplay="false" indicator-position="outside">
						<el-carousel-item v-for="(x,index) in img_list" :key="index">
							<img class="lun_img" :src="x.url" />
						</el-carousel-item>
					</el-carousel>
				</div>
			</div>
		</div>
		<p class="crumbs">
			<span>您的位置 : 
			<router-link to="/Index">首页</router-link> > 
      		<span @click="$router.back(-1)" class="pointer">社科成果库</span> > 
			<a>大事记图片</a></span>
		</p>
		<div class="details_main_box">
			<h3 class="title_ txt_center">{{title}}</h3>
			<section class="img_section">
				<img v-for=" (x,i) in img_list" :src="x.url" class="left" @click="current_img = i;big_show = true" />
			</section>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				artical: {},
				title: "2016.10.29-30中国梦：协调发展与全面建设小康社会学术前沿论坛",
				img_list: [],
				current_img: 1,
				big_show: false
			}
		},
		methods: {
			
		},
		mounted() {
			this.img_list = require("../../static/json/memorabilia.json").img_list;
			console.log(this.img_list)
			// this.$api.axios_memorabilia_img(this.$route.query.id).then(res => {
			// 	this.img_list = res.img_list;
			// 	console.log(this.img_list)
			// })
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	@import url("../assets/css/details");
	.img_section {
		width: 880px;
		height: auto;
		overflow: hidden;
		background: none;
		margin-left: 50px;
		margin-bottom: 80px;
	}
	
	.img_section img {
		width: 200px;
		height: 200px;
		display: block;
		margin-right: 20px;
		margin-bottom: 20px;
	}
	
	.title_ {
		line-height: 20px;
		height: 20px;
		margin: 20px auto 20px;
	}
	
	.fix_bg {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, .6);
		z-index: 9;
	}
	
	.no_bg_fix {
		width: 100%;
		height: 100%;
		pointer-events: stroke;
	}
	
	.lun_box {
		width: 746px;
		height: 532px;
		position: absolute;
		top: 50%;
		left: 50%;
		margin-top: -266px;
		margin-left: -373px;
	}
	.close_icon{
		margin-top: -20px;
		margin-right: -20px;
		font-size: 40px;
		width: 40px;
		height: 40px;
		color: #A8071A;
		line-height: 40px;
		position: relative;
		right: 80px;
		z-index: 99;
	}
	.close_x{
		width: 20px;
		height: 20px;
		background:#FFFFFF;
		position: absolute;
		top: 10px;
		left: 10px;
		z-index: 1;
	}
	.close_icon i{
		position: absolute;
		top: 0;
		left: 0;
		display: block;
		z-index: 2;
	}
	.lun_img{
		width: 605px;
		height: 100%;
		margin-left: 60px;
	}
</style>


// WEBPACK FOOTER //
// src/components/memorabilia_img.vue